import React, { Fragment, useContext, useEffect } from 'react';
import { Row, Col, Avatar } from 'antd';
import { withRouter } from 'react-router-dom';
import { StoreContext } from '../containers/Store';
import DashboardStudent from '../components/DashboardStudent';
import StudentImage from '../assets/images/student.png';

import * as ROUTES from '../constants/routes';

const Dashboard = ({ history }) => {
  const {
    user: {
      user,
    },
  } = useContext(StoreContext);

  useEffect(() => {
    return () => console.log('Dashboard unmounted');
  }, [])

  const clickStudent = () => {
    history.push(ROUTES.STUDENT);
  }

  const clickOtherStudent = () => {
    history.push(ROUTES.OTHERSTUDENT)
  }

  if (!!user && user.roles.includes("STUDENT_DEMO")) {
    return (
      <DashboardStudent student={user} />
    );
  } else if (!!user && user.roles.includes("TEACHER_DEMO")) {
    return (
      <Fragment>
        <Row style={{ display: 'flex' }}>
          <Col xs={12} sm={8} md={4}>
              <Avatar
                src={StudentImage}
                size= 'large'
                shape='square'
                style={{ 
                  height: '100px',
                  width: '100px',
                  cursor: 'pointer', 
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  margin: 'auto',
                  marginLeft: '40px',
                  backgroundColor: 'white'
                }}
                onClick={clickStudent}
            />
            <div style={{ textAlign: 'center', padding: '4px', fontWeight: 'bold'}}>Élève 1</div>
          </Col>
          <Col xs={12} sm={8} md={4}>
            <Avatar
                src={StudentImage}
                size= 'large'
                shape='square'
                style={{ 
                  height: '100px',
                  width: '100px',
                  cursor: 'pointer', 
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  margin: 'auto',
                  marginLeft: '40px',
                  backgroundColor: 'white'
                }}
                onClick={clickOtherStudent}
            />
            <div style={{ textAlign: 'center', padding: '4px', fontWeight: 'bold'}}>Élève 2</div>
          </Col>
          <Col xs={12} sm={8} md={4}>
            <Avatar
                src={StudentImage}
                size= 'large'
                shape='square'
                style={{ 
                  height: '100px',
                  width: '100px',
                  cursor: 'pointer', 
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  margin: 'auto',
                  marginLeft: '40px',
                  backgroundColor: 'white'
                }}
                onClick={clickOtherStudent}
            />
            <div style={{ textAlign: 'center', padding: '4px', fontWeight: 'bold'}}>Élève 3</div>
          </Col>
          <Col xs={12} sm={8} md={4}>
            <Avatar
                src={StudentImage}
                size= 'large'
                shape='square'
                style={{ 
                  height: '100px',
                  width: '100px',
                  cursor: 'pointer', 
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  margin: 'auto',
                  marginLeft: '40px',
                  backgroundColor: 'white'
                }}
                onClick={clickOtherStudent}
            />
            <div style={{ textAlign: 'center', padding: '4px', fontWeight: 'bold'}}>Élève 4</div>
          </Col>
          <Col xs={12} sm={8} md={4}>
            <Avatar
                src={StudentImage}
                size= 'large'
                shape='square'
                style={{ 
                  height: '100px',
                  width: '100px',
                  cursor: 'pointer', 
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  margin: 'auto',
                  marginLeft: '40px',
                  backgroundColor: 'white'
                }}
                onClick={clickOtherStudent}
            />
            <div style={{ textAlign: 'center', padding: '4px', fontWeight: 'bold'}}>Élève 5</div>
          </Col>
        </Row>
        <Row style={{ display: 'flex' }}>
          <Col xs={12} sm={8} md={4}>
              <Avatar
                src={StudentImage}
                size= 'large'
                shape='square'
                style={{ 
                  height: '100px',
                  width: '100px',
                  cursor: 'pointer', 
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  margin: 'auto',
                  marginLeft: '40px',
                  backgroundColor: 'white'
                }}
                onClick={clickOtherStudent}
            />
            <div style={{ textAlign: 'center', padding: '4px', fontWeight: 'bold'}}>Élève 6</div>
          </Col>
          <Col xs={12} sm={8} md={4}>
            <Avatar
                src={StudentImage}
                size= 'large'
                shape='square'
                style={{ 
                  height: '100px',
                  width: '100px',
                  cursor: 'pointer', 
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  margin: 'auto',
                  marginLeft: '40px',
                  backgroundColor: 'white'
                }}
                onClick={clickOtherStudent}
            />
            <div style={{ textAlign: 'center', padding: '4px', fontWeight: 'bold'}}>Élève 7</div>
          </Col>
          <Col xs={12} sm={8} md={4}>
            <Avatar
                src={StudentImage}
                size= 'large'
                shape='square'
                style={{ 
                  height: '100px',
                  width: '100px',
                  cursor: 'pointer', 
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  margin: 'auto',
                  marginLeft: '40px',
                  backgroundColor: 'white'
                }}
                onClick={clickOtherStudent}
            />
            <div style={{ textAlign: 'center', padding: '4px', fontWeight: 'bold'}}>Élève 8</div>
          </Col>
          <Col xs={12} sm={8} md={4}>
            <Avatar
                src={StudentImage}
                size= 'large'
                shape='square'
                style={{ 
                  height: '100px',
                  width: '100px',
                  cursor: 'pointer', 
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  margin: 'auto',
                  marginLeft: '40px',
                  backgroundColor: 'white'
                }}
                onClick={clickOtherStudent}
            />
            <div style={{ textAlign: 'center', padding: '4px', fontWeight: 'bold'}}>Élève 9</div>
          </Col>
          <Col xs={12} sm={8} md={4}>
            <Avatar
                src={StudentImage}
                size= 'large'
                shape='square'
                style={{ 
                  height: '100px',
                  width: '100px',
                  cursor: 'pointer', 
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  margin: 'auto',
                  marginLeft: '40px',
                  backgroundColor: 'white'
                }}
                onClick={clickOtherStudent}
            />
            <div style={{ textAlign: 'center', padding: '4px', fontWeight: 'bold'}}>Élève 10</div>
          </Col>
        </Row>
      </Fragment>
    )
  } else {
    console.log("Should not happen, component Dashboard");
    return null;
  }
};

export default withRouter(Dashboard);